import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';
import { Box, TextField } from '@mui/material';
import { Link } from 'react-router-dom'
import DoneIcon from '@mui/icons-material/Done';
import { OptionWithSelect, FilterCategory, Filter } from './FilterTypes';
import { ReactNode, useEffect, useState } from 'react';
import _ from 'lodash';
import PerfectScrollbar from 'react-perfect-scrollbar'
import SprintStore from '../../stores/SprintStore';
import BlockIcon from '@mui/icons-material/Block';

export interface SimpleDialogProps { 
    open: boolean;
    selectedValue: string;
    onClose: (value: string) => void;
    category: FilterCategory;
    toggleOption: (cat: FilterCategory, opt: OptionWithSelect) => void;
    defaultSearchValue: string;
    filter: Filter,
}

function SimpleDialog(props: SimpleDialogProps) {
    //const leadFilters = SprintStore.useState(s => s.leadFilters);
    const [searchValue, setSearchValue] = useState('')
    const { onClose, selectedValue, open, category, toggleOption, defaultSearchValue, filter } = props;
    const [optionsFiltered, setOptionsFiltered] = useState([] as OptionWithSelect[])

    useEffect(() => {
        setSearchValue(defaultSearchValue);
    }, [defaultSearchValue])

    useEffect(() => {
        let clonedOptions = _.cloneDeep(category.options);

        const upperCasedValue = searchValue.toUpperCase();

        clonedOptions = clonedOptions.filter(s => upperCasedValue === '' || s.name.toUpperCase().includes(upperCasedValue));

        setOptionsFiltered(clonedOptions);
    }, [searchValue, category])

    const handleClose = () => {
        onClose(selectedValue);
    };

    const getOptionIcon = (opt: OptionWithSelect, cat: FilterCategory): ReactNode => {
        const selectedOption = filter.options.find(op => op.value === opt.value && op.optionType === cat.optionType);
        
        if (selectedOption) {
            return selectedOption.inclusive ? <DoneIcon sx={{ color: 'green', sx: { mr: 2.5 } }} /> : <BlockIcon sx={{ color: 'red', sx: { mr: 2.5 } }} />
        }

        return <DoneIcon sx={{ color: 'green', opacity: 0, sx: { mr: 2.5 } }} />;
    }


    return (
        <Dialog onClose={handleClose} fullWidth maxWidth='md' open={open} PaperProps={{
            sx: {
                minHeight: '60vh',
                maxHeight: '60vh',
                padding: 5
            }
        }}>
            <DialogTitle>{category.category}</DialogTitle>

            <TextField name={`${category.optionType}-filter`} autoFocus value={searchValue} onChange={(e) => setSearchValue(e.target.value)} size='small' fullWidth sx={{ mb: 4, pr: 4 }} />

            <PerfectScrollbar options={{ wheelPropagation: false }} id='filters-card' className='ps-show-always'>
                <Box sx={{ maxHeight: '50vh', minHeight: '50vh' }}>
                    <List sx={{ pt: 0 }} >
                        {optionsFiltered.map((opt) => (
                            <ListItem button onClick={() => toggleOption(category, opt)} key={opt.value}>
                                {getOptionIcon(opt, category)}
                                {/*{leadFilters.options.some(op => op.value === opt.value && op.optionType === category.optionType) ? <DoneIcon sx={{ color: 'green', sx: { mr: 2.5 } }} /> : <DoneIcon sx={{ color: 'lightgray', opacity: 0, sx: { mr: 2.5 } }} />}*/}
                                <ListItemText primary={opt.name} />
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </PerfectScrollbar>
        </Dialog>
    );
}

type Props = {
    children: React.ReactNode,
    category: FilterCategory,
    toggleOption: (cat: FilterCategory, opt: OptionWithSelect) => void,
    defaultSearchValue: string,
    filter: Filter,
}

const FilterDialog = ({ children, category, toggleOption, defaultSearchValue, filter }: Props) => {
    const [open, setOpen] = React.useState(false);
    const [selectedValue, setSelectedValue] = React.useState(category.options[1].value);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (value: string) => {
        setOpen(false);
        setSelectedValue(value);
    };

    return (
        <div>
            <Link to='' onClick={handleClickOpen}>
                <Box
                    component='a'
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        '&:hover > *': { color: 'primary.main' }
                    }}
                >
                    {children}
                </Box>
            </Link>
            <SimpleDialog
                filter={filter}
                selectedValue={selectedValue}
                open={open}
                onClose={handleClose}
                category={category}
                toggleOption={toggleOption}
                defaultSearchValue={defaultSearchValue}
            />
        </div>
    );
}

export { FilterDialog }
export default FilterDialog